module.exports = __webpack_public_path__ + "static/img/female.74e32598.png";